import { render, staticRenderFns } from "./playad-add-or-update.vue?vue&type=template&id=05fdf02a"
import script from "./playad-add-or-update.vue?vue&type=script&lang=js"
export * from "./playad-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./playad-add-or-update.vue?vue&type=style&index=0&id=05fdf02a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports